import React from "react";
import HomePageLayout from "../component/homePageLayout/HomePageLayout";
import ProjectComponent from "../component/projects/ProjectComponent";

const Projects = () => {
  return (
    <HomePageLayout>
      <ProjectComponent />
    </HomePageLayout>
  );
};

export default Projects;
